import React from 'react';
import { Polyline } from '@react-google-maps/api';

/**
 * Draws dashed lines from the subject property to each traffic sensor
 * colour-coded by AADT, so you can visually see which roads are measured.
 */
const SensorConnectionLayer = ({ center, sensors = [] }) => {
  if (!center || center.lat == null || center.lng == null) return null;

  return (
    <>
      {sensors.map((sensor, idx) => {
        const lat = sensor.location?.lat ?? sensor.latitude;
        const lon = sensor.location?.lon ?? sensor.location?.lng ?? sensor.longitude;
        if (lat == null || lon == null) return null;

        const aadt = sensor.latest_aadt || 0;
        const color =
          aadt > 60000 ? '#ef4444' :
          aadt > 30000 ? '#f97316' :
          aadt > 15000 ? '#eab308' : '#22c55e';

        return (
          <Polyline
            key={`conn-${sensor.station_id || idx}`}
            path={[center, { lat: Number(lat), lng: Number(lon) }]}
            options={{
              strokeColor: color,
              strokeOpacity: 0.6,
              strokeWeight: 2,
              icons: [{
                icon: {
                  path: 'M 0,-1 0,1',
                  strokeOpacity: 1,
                  strokeWeight: 2,
                  scale: 3,
                },
                offset: '0',
                repeat: '14px',
              }],
              clickable: false,
              zIndex: 1,
            }}
          />
        );
      })}
    </>
  );
};

export default SensorConnectionLayer;
